import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import { useSession } from './auth.js';
import { api } from './runtime.js';

/** Appel de l'API avec le jeton de la session courante. */
export function useApi(): <T>(path: string, init?: RequestInit) => Promise<T> {
  const { user } = useSession();
  return (path, init) => api(user, path, init);
}

/** Lecture mise en cache (TanStack Query), clé = chemin de l'API. */
export function useApiQuery<T>(path: string | null, refetchInterval?: number): UseQueryResult<T> {
  const call = useApi();
  return useQuery<T>({
    queryKey: [path],
    queryFn: () => call<T>(path ?? ''),
    enabled: path !== null,
    ...(refetchInterval === undefined ? {} : { refetchInterval }),
  });
}
